import { render, staticRenderFns } from "./companyTotal.vue?vue&type=template&id=6647cfb0&scoped=true"
import script from "./companyTotal.vue?vue&type=script&lang=js"
export * from "./companyTotal.vue?vue&type=script&lang=js"
import style0 from "./companyTotal.vue?vue&type=style&index=0&id=6647cfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647cfb0",
  null
  
)

export default component.exports